// Color utility for resume templates
// Maps color names to Tailwind class names

export interface ColorClasses {
  // Header/Primary colors
  headerBg: string
  headerText: string

  // Section headers
  sectionTitle: string
  sectionBorder: string

  // Accents
  accentBg: string
  accentText: string
  accentBorder: string

  // Timeline/decorative elements
  timelineBorder: string
  timelineDot: string

  // Tags/badges
  badgeBg: string
  badgeText: string
}

export function getColorClasses(color: string = 'blue'): ColorClasses {
  const colorMap: Record<string, ColorClasses> = {
    blue: {
      headerBg: 'from-blue-100 to-blue-200',
      headerText: 'text-blue-900',
      sectionTitle: 'text-blue-700',
      sectionBorder: 'border-blue-200',
      accentBg: 'bg-blue-100',
      accentText: 'text-blue-700',
      accentBorder: 'border-blue-600',
      timelineBorder: 'border-blue-300',
      timelineDot: 'bg-blue-400',
      badgeBg: 'bg-blue-50',
      badgeText: 'text-blue-600'
    },
    purple: {
      headerBg: 'from-purple-100 to-purple-200',
      headerText: 'text-purple-900',
      sectionTitle: 'text-purple-700',
      sectionBorder: 'border-purple-200',
      accentBg: 'bg-purple-100',
      accentText: 'text-purple-700',
      accentBorder: 'border-purple-600',
      timelineBorder: 'border-purple-300',
      timelineDot: 'bg-purple-400',
      badgeBg: 'bg-purple-50',
      badgeText: 'text-purple-600'
    },
    green: {
      headerBg: 'from-green-100 to-green-200',
      headerText: 'text-green-900',
      sectionTitle: 'text-green-700',
      sectionBorder: 'border-green-200',
      accentBg: 'bg-green-100',
      accentText: 'text-green-700',
      accentBorder: 'border-green-600',
      timelineBorder: 'border-green-300',
      timelineDot: 'bg-green-400',
      badgeBg: 'bg-green-50',
      badgeText: 'text-green-600'
    },
    pink: {
      headerBg: 'from-pink-100 to-pink-200',
      headerText: 'text-pink-900',
      sectionTitle: 'text-pink-700',
      sectionBorder: 'border-pink-200',
      accentBg: 'bg-pink-100',
      accentText: 'text-pink-700',
      accentBorder: 'border-pink-600',
      timelineBorder: 'border-pink-300',
      timelineDot: 'bg-pink-400',
      badgeBg: 'bg-pink-50',
      badgeText: 'text-pink-600'
    },
    amber: {
      headerBg: 'from-amber-100 to-amber-200',
      headerText: 'text-amber-900',
      sectionTitle: 'text-amber-700',
      sectionBorder: 'border-amber-200',
      accentBg: 'bg-amber-100',
      accentText: 'text-amber-700',
      accentBorder: 'border-amber-600',
      timelineBorder: 'border-amber-300',
      timelineDot: 'bg-amber-400',
      badgeBg: 'bg-amber-50',
      badgeText: 'text-amber-600'
    },
    teal: {
      headerBg: 'from-teal-100 to-teal-200',
      headerText: 'text-teal-900',
      sectionTitle: 'text-teal-700',
      sectionBorder: 'border-teal-200',
      accentBg: 'bg-teal-100',
      accentText: 'text-teal-700',
      accentBorder: 'border-teal-600',
      timelineBorder: 'border-teal-300',
      timelineDot: 'bg-teal-400',
      badgeBg: 'bg-teal-50',
      badgeText: 'text-teal-600'
    }
  }

  return colorMap[color] || colorMap.blue
}
